import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";

export default function SwiperImagesComponent({images}) {
    return (
        <Swiper
            className="min-h-[600px]"
            slidesPerView={1}
            spaceBetween={0}
            loop={true}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false
            }}
            pagination={{
                clickable: true,
            }}
            navigation={true}
            modules={[Pagination, Navigation, Autoplay]}
        >
            {images.map((image, i) => {
                return (
                    <SwiperSlide
                        key={i}
                        className="min-h-[600px]"
                        style={{
                            backgroundImage: `url(${image})`,
                            backgroundPosition: "center center",
                            backgroundSize: "cover",
                        }}
                    />
                )
            })}
        </Swiper>
    )
}